import AlertsConfigPage from "@/pages/AlertsConfigPage";
export default function PartnerAlerts() { return <AlertsConfigPage scope="partner" path="/partner/alerts" />; }
